export default __webpack_public_path__ + "static/media/info-balls.e61620e0.png";